module.exports = __webpack_public_path__ + "img/logo-dark-medium.53e780f7.png";